// Restrained, curated ContentOS palette. Values are mid-tone hues that read
// clearly as an accent on BOTH light and dark surfaces when used as a tinted
// chip (translucent background + solid foreground) — never as a full fill.
export const APPEARANCE_PALETTE = [
  { name: "Slate", value: "#64748b" },
  { name: "Indigo", value: "#6366f1" },
  { name: "Violet", value: "#8b5cf6" },
  { name: "Blue", value: "#3b82f6" },
  { name: "Sky", value: "#0ea5e9" },
  { name: "Teal", value: "#14b8a6" },
  { name: "Emerald", value: "#10b981" },
  { name: "Amber", value: "#f59e0b" },
  { name: "Orange", value: "#f97316" },
  { name: "Rose", value: "#f43f5e" },
  { name: "Pink", value: "#ec4899" },
  { name: "Stone", value: "#78716c" },
];

// Tinted chip style: translucent bg + solid text/border in the accent hue.
// Works identically in light and dark themes (theme-independent inline colour).
export function chipStyle(colour) {
  if (!colour) return undefined;
  return { backgroundColor: `${colour}1F`, color: colour, borderColor: `${colour}40` };
}

// Subtle accent style for headers (thin left rule + faint wash).
export function accentStyle(colour) {
  if (!colour) return undefined;
  return { borderColor: `${colour}59`, backgroundColor: `${colour}0F` };
}
